/**
 * Shared patch merge for socket `newMessage` updates: keep hydrated fields when
 * the incoming payload omits them (undefined), overwrite when defined.
 */
export const mergeMessagePatch = (existing, patch) => {
  if (!existing) {
    return patch;
  }
  if (!patch) {
    return existing;
  }
  return {
    ...existing,
    ...Object.fromEntries(Object.entries(patch).filter(([, v]) => v !== undefined)),
  };
};
